<template>
    <router-view v-if="admin"></router-view>
</template>

<script>
import {firebase} from '../../firebase/firebaseConfig';

export default {
    name: 'AdminZone',
    data: () => ({
        admin: false,
    }),
    mounted() {
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                console.log('user', user);
                user.getIdTokenResult().then(token => {
                    if (token.claims.admin) {
                        this.admin = true
                    } else {
                        this.$router.replace({name: 'home-page'})
                    }
                })
            } else {
                this.$router.replace({name: 'home-page'})
            }
        })
    }
}
</script>
